import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/productManagement/brands/all')
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/productManagement/brands?id=${id}`)
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/productManagement/brands/${id}`
      : '/api/productManagement/brands'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/productManagement/brands/${id}`)
  }
}
